import { ToolBarContext } from '../components/ToolBar/ToolBarContext';
import { jsx as _jsx } from "react/jsx-runtime";
const TOOLBAR_CONTEXT_VALUE = {
  use: undefined
};

/*
 * This "context" is used as a catch-all wrapper where we can reset any context that might
 * affect portaled components like modals and popovers
 */
export const ResetContext = ({
  children
}) => {
  return /*#__PURE__*/_jsx(ToolBarContext.Provider, {
    value: TOOLBAR_CONTEXT_VALUE,
    children: children
  });
};